module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"categories-row":{"articles":"Varer"}},"de":{"version":1,"categories-row":{"articles":"Artikel"}},"en":{"categories-row":{"articles":"Articles"}},"fr":{"categories-row":{"articles":"Articles"}},"nl":{"categories-row":{"articles":"Artikel"}},"pl":{"categories-row":{"articles":"Artykuł"}}}')
  delete Component.options._Ctor
}
